import { render, staticRenderFns } from "./update-policy.vue?vue&type=template&id=5cf5f3e8&scoped=true"
import script from "./update-policy.vue?vue&type=script&lang=js"
export * from "./update-policy.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cf5f3e8",
  null
  
)

export default component.exports